import { Box, Button, MenuItem, Modal, TextField, Typography } from "@mui/material";
import { Check, User } from "lucide-react";
import "./ConfirmInformationModal.scss"
import { useState } from "react";
import { getHeaders, URI_API } from "../../utils/config";

export default function ConfirmInformationModal (props: {
    showComponent: boolean;
    closeComponent: any;
    onContinue: (nominaNumber: string, classx: string, vitalSupport: string, nominaExists: boolean) => void;
    name: string;
    hospital: string;
}) {

    const [nominaNumber, setNominaNumber] = useState<string>("");
    const [classX, setClassx] = useState<string>("");
    const [vitalSupport, setVitalSupport] = useState<string>("");
    const [nominaNumberExists, setNominaNumberExists] = useState(false);
    const [nominaName, setNominaName] = useState("");

    const classxOptions = ["COORD", "ENF ESP", "ENF SUB", "ENF A", "ENF B", "ENF C", "AUX A", "AUX B", "AUX C", "AUX"];
    const vitalSupportOptions = ["BLS", "PALS", "NALS", "PALS NALS"];

    const handleClassxChange = (e: any) => {
        setClassx(e.target.value);
    }

    const handleNominaChange = (e: any) => {
        setNominaNumberExists(false);
        setNominaNumber(e.target.value);
    }

    const handleVitalSupportChange = (e: any) => {
        setVitalSupport(e.target.value);
    }

    const handleRepeatedNomina = () => {
        props.onContinue(nominaNumber, classX, vitalSupport, true);
    }

    const continueLoginFlow = async () => {
        const nomina_exists = await fetch(`${URI_API}/nurse_exists`, 
                    getHeaders("POST", {
						nominaNumber: nominaNumber,
						hospital: props.hospital,
					}),);
        const response = await nomina_exists.json();
        if (response.exists === true) {
            setNominaNumberExists(true);
            setNominaName(response.name);
        }
        else {
            props.onContinue(nominaNumber, classX, vitalSupport, false);
        }
        console.log(response.exists);
    }
        
    return (
        <>
            <Modal
                open={props.showComponent}
                onClose={props.closeComponent}
            >
                <Box className="confirm-modal">
                    <Box className="confirm-modal__header">
                        <img
                            className="confirm-modal__header-grain"
                            src={require("../../assets/images/grain.png")}
                            alt="background"
                        />
                        <Box className="confirm-modal__header__title-container">
                            <User size={25} className="confirm-modal__header__title-container-icon" />
                            <Box>
                                <Typography className="confirm-modal__header__title-container__text-title">
                                    ¡Hola, {props.name}!
                                </Typography>
                                <Typography className="confirm-modal__header__title-container__text-subtitle">
                                    Por favor completa tus datos para continuar.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box className="confirm-modal__body">
                        <Box className="confirm-modal__body__nomina">
                            <Typography className="confirm-modal__body__nomina-title-text">
                                Número de nómina
                            </Typography>
                            <TextField 
                                onChange={handleNominaChange} 
                                id="SelectNominaNumber" 
                                variant="outlined" 
                                size="small" 
                                fullWidth 
                            />
                            {!nominaNumberExists && (
                                <Typography className="confirm-modal__body__nomina-label-text">
                                    Ten en cuenta que este dato no podrá ser editado más adelante.
                                </Typography>
                            )}
                            {nominaNumberExists && (
                                <Box className="confirm-modal__body__nomina__exists">
                                    <Typography>
                                        Ya existe este número de nómina. Está ligado al nombre {nominaName}, ¿deseas asociarlo con este usuario? Esta acción no se puede revertir. 
                                    </Typography> 
                                    <Button 
                                        className="confirm-modal__body__nomina__exists-button"
                                        onClick={handleRepeatedNomina}
                                    >
                                        Sí
                                    </Button>
                                </Box>
                            )
                        }
                        </Box>
                        <Box className="confirm-modal__body__category">
                            <Typography>
                                Categoría
                            </Typography>
                            <TextField 
                                onChange={handleClassxChange} 
                                defaultValue="" 
                                id="SelectClassx" 
                                select 
                                variant="outlined" 
                                size="small" 
                                fullWidth
                            >
                                {classxOptions.map((classx) => (
                                    <MenuItem 
                                        key={classx} 
                                        value={classx}
                                    >
                                        {classx}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Box>
                        <Box className="confirm-modal__body__support">
                            <Typography>
                                Soporte vital
                            </Typography>
                            <TextField 
                                onChange={handleVitalSupportChange} 
                                defaultValue="" 
                                id="SelectVitalSupport" 
                                select 
                                variant="outlined" 
                                size="small" 
                                fullWidth
                            >
                                {vitalSupportOptions.map((option) => (
                                    <MenuItem 
                                        key={option} 
                                        value={option}
                                    >
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Box>
                        <Box className="confirm-modal__body__buttons">
                            <Button
                                className="confirm-modal__body__buttons__close"
                                onClick={props.closeComponent}
                            >
                                Cerrar
                            </Button>
                            <Button
                                className="confirm-modal__body__buttons__confirm"
                                disabled={
                                    nominaNumber === "" 
                                    || classX === ""
                                    || vitalSupport === ""}
                                onClick={continueLoginFlow}
                            >
                                <Check /> Guardar
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}